export const wifiCallingBannerContent = {
  bannerText: 'All plans include WiFi Calling to supercharge your signal',
  learnMoreLabel: 'Learn more',
  learnMoreUrl: 'https://smarty.co.uk/blog/wifi-calling',
  learnMoreTrackingName: 'learn-more-wifi-calling',
}
